import clsx from "clsx";

const TallOuterContainer = ({ children, dynamicHeight }) => {
    const heightClass =`h-[${dynamicHeight}px]`;

    return (
        <div className={clsx("", heightClass)}>
            {children}
        </div>
    );
}

export default TallOuterContainer;